/**
 * Thin helper for pushing custom events to the GTM `dataLayer`.
 *
 * The `dataLayer` and the Google Consent Mode v2 defaults are bootstrapped in
 * `app/layout.tsx` (the inline GTM <Script>, wired to the Cookiebot consent
 * signals). We push plain `{ event, ... }` objects — the standard GTM
 * custom-event format — rather than pulling in `@next/third-parties`, to stay
 * consistent with that hand-wired consent bridge.
 *
 * IMPORTANT: never push PII (e-mail, names, raw URLs of users) into the
 * dataLayer — that data must not reach GA4. Pass only categorical metadata.
 */
declare global {
  interface Window {
    dataLayer?: Record<string, unknown>[];
  }
}

export function trackEvent(
  event: string,
  params: Record<string, unknown> = {},
): void {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer ?? [];
  window.dataLayer.push({ event, ...params });
}
